// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1008e137","171":"1b8a8255","432":"30b39bf9","994":"77588bb4"}[chunkId] + ".chunk.js";
};